import type { ReactNode } from "react";
import { useController, useFormContext } from "react-hook-form";

import { FormField } from "@/components/ui/form-field";
import type { CadastroDraft } from "@/lib/cadastro-draft";
import {
	CADASTRO_TEXT_FIELDS,
	type CadastroTextField,
	type CadastroTextKey,
} from "@/lib/cadastro-fields";

export function DraftField({
	fieldKey,
	span,
	labelAction,
	hint,
	autoFocus,
	disabled,
}: {
	fieldKey: CadastroTextKey;
	span?: boolean;
	labelAction?: ReactNode;
	hint?: string;
	autoFocus?: boolean;
	disabled?: boolean;
}) {
	const { control } = useFormContext<CadastroDraft>();
	const controlled = useController({ control, name: fieldKey });
	const field: CadastroTextField = CADASTRO_TEXT_FIELDS[fieldKey];
	const content = (
		<FormField
			label={field.label}
			labelAction={labelAction}
			value={controlled.field.value}
			onChange={(value) => controlled.field.onChange(field.mask ? field.mask(value) : value)}
			onBlur={controlled.field.onBlur}
			placeholder={field.placeholder}
			error={controlled.fieldState.error?.message}
			hint={hint}
			autoFocus={autoFocus}
			disabled={disabled}
			slot={fieldKey}
		/>
	);

	if (span) {
		return <div className="sm:col-span-2">{content}</div>;
	}

	return content;
}
